/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreatePortalSessionResult = {
  /**
   * Front-end token for the webhook portal session.
   */
  token: string;
  /**
   * URL for the webhook portal session.
   */
  url: string;
};

/** @internal */
export const CreatePortalSessionResult$inboundSchema: z.ZodMiniType<
  CreatePortalSessionResult,
  unknown
> = z.object({
  token: z.string(),
  url: z.string(),
});

export function createPortalSessionResultFromJSON(
  jsonString: string,
): SafeParseResult<CreatePortalSessionResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreatePortalSessionResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreatePortalSessionResult' from JSON`,
  );
}
